import { FreightCompanyData } from './limitedAccess';

export const ONBOARDING_STATUS_DO_NOT_DISPATCH = 'N';

export function getNeedsHighwaySignup(data?: FreightCompanyData): boolean {
  if (
    data?.onboardingStatus === null ||
    data?.onboardingStatus === ONBOARDING_STATUS_DO_NOT_DISPATCH
  ) {
    return true;
  }
  return false;
}
